import { render, staticRenderFns } from "./FormRenderer.vue?vue&type=template&id=42dfc012"
import script from "./FormRenderer.vue?vue&type=script&lang=ts"
export * from "./FormRenderer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports